<template>
  <div>
    <!-- Popup Modal -->
    <b-modal
      id="addVehicleCountModal"
      title="Add Vehicle Count"
      size="md"
      hide-footer
    >
      <b-form>

        <!-- Planning Date -->
        <b-form-group :label-cols="5">
          <template #label>
            Select Planning Date <span class="text-danger">*</span>
          </template>
          <v-date-picker
            mode="single"
            input-class="dateInput"
            :available-dates="{ start: new Date(), end: null }"
            v-model="dateSearch"
          >
          
          </v-date-picker>
           <div v-if="dateError" class="text-danger">
            Please select planning date.
          </div>

        </b-form-group>

        <!-- Hub -->
        <b-form-group :label-for="hubId">
          <template #label>
            Select Hub <span class="text-danger">*</span>
          </template>
          <b-form-select
            id="hubId"
            v-model="form.hubId"
            :options="hubItems"
          >
          </b-form-select>
          <div v-if="hubError" class="text-danger">
            Please select hub.
          </div>
        </b-form-group>

        <!-- Planned Regular Vehicle Count -->
        <b-form-group
          label="Planned Regular Vehicle Count"
          :label-for="regularVehicleCount"
        >
          <b-form-input
            id="regularVehicleCount"
            v-model="form.regularVehicleCount"
            @input="validateNumeric('regular')"
          ></b-form-input>

          <div v-if="regularCountError" class="text-danger">
            Only numeric value is allowed.
          </div>
        </b-form-group>

        <!-- Planned Adhoc Vehicle Count -->
        <b-form-group
          label="Planned Adhoc Vehicle Count"
          :label-for="adhocVehicleCount"
        >
          <b-form-input
            id="adhocVehicleCount"
            v-model="form.adhocVehicleCount"
            @input="validateNumeric('adhoc')"
          ></b-form-input>

          <div v-if="adhocCountError" class="text-danger">
            Only numeric value is allowed.
          </div>
        </b-form-group>

        <div v-if="atLeastOneCountError" class="text-danger">
          Please fill any one count value.
        </div>

        <!-- Buttons -->
        <div class="text-right">
          <b-button
            variant="success"
            class="mr-2"
            @click="AddCount"
            :disabled="isBusy"
          >
            <b-spinner v-if="isBusy" small></b-spinner>

            <span v-if="isBusy">Submitting...</span>
            <span v-else>Submit</span>
          </b-button>

          <b-button
            variant="secondary"
            @click="clearFields"
          >
            Reset
          </b-button>
        </div>

      </b-form>
    </b-modal>
  </div>
</template>

<script>

import CONSTANTS from '@/utils/constants'
export default {

  //props: {
  //  hubList: {
  //    type: Array,
  //    default: () => []
  //  }
  //},

  mounted() {
    this.hubListing();
  },

  data() {
    return {
      isBusy: false, 
      atLeastOneCountError: false,
      regularCountError: false,
      adhocCountError: false,
      dateError: false,
      hubError: false,

      dateSearch: null,
      hubItems: [
        {
          value: null,
          text: "- Select Hub -"
        }
      ],

      form: {
        hubId: null,
        regularVehicleCount: null,
        adhocVehicleCount: null
      }

    };
  },

  // watch: {
  //   hubList: {
  //     immediate: true,
  //     handler(newValue) {
  //       console.log("Hub List Received :", newValue);
  //       this.hubItems = [
  //         {
  //           value: null,
  //           text: "- Select Hub -"
  //         }
  //       ];

  //       newValue.forEach(item => {
  //         this.hubItems.push({
  //           value: item.hub_id,
  //           text: `${item.hub_name} - ${item.hub_id}`
  //         });
  //       });
  //     }
  //   }
  // },

  methods: {

      hubListing(){
        this.isBusy=true;
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        const obj={
        sysusermasterid:`${userInfo.sysusermasterid}`,
        usertype : `${userInfo.user_type}`,
        }
        console.log("objlist",obj)
        this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getAllHubListing`,obj)
        .then(result => {
            this.isBusy=false;
            if (result.body.returnmsg === "Successful") {
                this.hubItems = [
                    {
                        value: null,
                        text: "-Select Hub-"
                    }
                ];

                result.body.returnvalue.forEach(item => {
                    this.hubItems.push({
                        value: item.hubid,
                        text: `${item.hubname} - ${item.hubid} `
                    });
                });

            }else{
                this.hubItems=[];
            //  this.totalRows=0;
            }
            }).catch(ex => {
            console.log("error", ex);
        });
    },
       
      AddCount() {
        // Check planning date
        if (!this.dateSearch) {
          this.dateError = true;
          return;
        }

        this.dateError = false;

        // Check hub
        if (!this.form.hubId) {
          this.hubError = true;
          return;
        }

        this.hubError = false;

        // Check at least one vehicle count
        if (
          (this.form.regularVehicleCount === null ||
            this.form.regularVehicleCount === '') &&
          (this.form.adhocVehicleCount === null ||
            this.form.adhocVehicleCount === '')
        ) {
          this.atLeastOneCountError = true;
          return;
        }

        this.atLeastOneCountError = false;

        // Check numeric validation
        if (this.regularCountError || this.adhocCountError) {
          return;
        }

        // Check before submitting
        if ( (this.form.regularVehicleCount === null || this.form.regularVehicleCount === '') &&
          (this.form.adhocVehicleCount === null || this.form.adhocVehicleCount === '')
        ) {
          this.atLeastOneCountError = true;
          return;
        }

        this.atLeastOneCountError = false;

        // Existing numeric validation
        if (this.regularCountError || this.adhocCountError) {
          return;
        }

        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
       
        this.isBusy=true;

        let obj = {
            hub_id: this.form.hubId,
            planned_date: this.formatDate(this.dateSearch),
            regular_vehicle_count: this.form.regularVehicleCount,
            adhoc_vehicle_count: this.form.adhocVehicleCount,
            user: userInfo.userfirstname + " " + userInfo.userlastname,
            fileS3_location: null
        };

        console.log("Request Payload :", obj);

        this.$http.post(
            `${CONSTANTS.MISREPORT_API_URL}/addPlannedVehiclesCount`,
            obj
        )
        .then(result => {
          this.isBusy=false;
            console.log("API Response :", result.body);

            if (result.body.returnmsg === "Successful") {
                // alert("Vehicle Count Added Successfully");
                this.clearFields();

                this.$bvModal.hide("addVehicleCountModal");

                // Refresh parent listing
                this.$emit("refreshListing");

            } else {
                this.$toasted.error(result.body.returnvalue);
            }
        })
        .catch(error => {
            this.isBusy=false;
            console.log("API Error :", error);
            alert("Something went wrong.")
        });
    },

    clearFields() {
      this.dateSearch = null;
      this.form = {
          hubId: null,
          regularVehicleCount: null,
          adhocVehicleCount: null
      };
      this.adhocCountError = false;
      this.regularCountError = false;
      this.atLeastOneCountError = false;
    },

    formatDate(date) {
      if (!date) return null;

      let d = new Date(date);

      let year = d.getFullYear();
      let month = ("0" + (d.getMonth() + 1)).slice(-2);
      let day = ("0" + d.getDate()).slice(-2);

      return `${year}-${month}-${day}`;
    },

    validateNumeric(type) {
      if (type === 'regular') {
        this.regularCountError =
          this.form.regularVehicleCount !== null &&
          this.form.regularVehicleCount !== '' &&
          !/^\d+$/.test(this.form.regularVehicleCount);
      }

      if (type === 'adhoc') {
        this.adhocCountError =
          this.form.adhocVehicleCount !== null &&
          this.form.adhocVehicleCount !== '' &&
          !/^\d+$/.test(this.form.adhocVehicleCount);
      }
    },

  }
};
</script>